<template>
  <div>
    <el-dialog
      :title="type === 'All' ? '全部部署' : '部署'"
      visible
      :close-on-click-modal="false"
      width="600px"
      append-to-body
      :before-close="close"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          label-width="100px"
        >
          <el-form-item
            v-if="type !== 'All'"
            label="名称"
          >
            {{ value.name + '.' + value.type }}
          </el-form-item>
          <el-form-item
            label="部署描述"
            prop="description"
            :rules="{required: true, message: '请输入部署描述', trigger: 'blur'}"
          >
            <el-input
              v-model.trim="form.description"
              type="textarea"
              :rows="5"
              placeholder="请输入部署描述"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="close">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="publish"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        codeId: this.value.id,
        codeName: this.value.name,
        codeType: this.value.type,
        description: ''
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    publish() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return this.$message.error('请输入部署描述！')
        }
        if (this.type === 'All') {
          this.publishAll()
          return
        }
        this.$api.public.publish([this.form]).then(() => {
          this.$message.success('部署成功!')
          this.close()
        })
      })
    },
    publishAll() {
      this.$api.public.selectAll().then(data => {
        this.$api.public.publish(data.map(item => {
          return {
            codeId: item.id,
            codeName: item.name,
            codeType: item.type,
            description: this.form.description
          }
        })).then(() => {
          this.$message.success('全部部署成功!')
          this.close()
        })
      })
    }
  }
}
</script>
